import { useQuery } from '@apollo/client'
import { useDsnApiV2 } from 'services/axios'
import { MY_IMS_ORGS, MY_LAUNCH_QUERY, MY_ACC_QUERY, MY_ENVIRONMENTS_QUERY } from 'config/operations'

export const useMyImsOrgs = () => {
  const { loading, error, data } = useQuery(MY_IMS_ORGS)
  const myImsOrgs = data?.myIMSOrgs || []
  return { loading, error, data: myImsOrgs }
}

export const useMyLaunch = () => {
  const { loading, error, data } = useQuery(MY_LAUNCH_QUERY)
  const myLaunchConfigs = data ? data.myLaunch || [] : []
  return { loading, error, data: myLaunchConfigs }
}

export const useMyAcc = () => {
  const { loading, error, data } = useQuery(MY_ACC_QUERY)
  const myAccInstances = data ? data.myACC || [] : []
  return { loading, error, data: myAccInstances }
}

export const useMyEnvironments = () => {
  const { loading, error, data } = useQuery(MY_ENVIRONMENTS_QUERY)
  const { imsOrgs, sandboxes, launchProperties = [] } = data?.myEnvironments || {}

  const mappedProperties = launchProperties.map((p) => ({
    ...p,
    sandboxName: sandboxes.find((s) => s.id === p.aepID)?.sandboxName || null,
  }))

  const myEnvironments = { imsOrgs, sandboxes, launchProperties: mappedProperties }

  return { loading, error, data: myEnvironments }
}

export const useLaunchDetails = ({ propertyId, appId, imsOrgID }) => {
  const [{ loading, error, data }, fetch] = useDsnApiV2({
    method: 'GET',
    url: `/launch`,
    params: { propertyId, appId, imsOrgID },
  })
  const launchDetails = data && {
    propertyName: data.attributes?.name,
    propertyID: data.id,
    company: data.relationships?.company?.data?.id,
    solutions: data.solutions,
  }
  return { loading, error, launchDetails, fetch }
}
